import Persian from "./Persian";

function toEnglish(val) {
  return val ? Persian(val).toEnglishNumber().toString() : val;
}

export function toPersian(val) {
  if (val === 0) return "۰";
  return val ? Persian(val).englishNumber().toString() : val;
}

export function formatPrice(val) {
  return String(val).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

export function persianPrice(val) {
  return formatPrice(val);
}

function weekDayFromNumer(number) {
  switch (number) {
    case 1:
      return "شنبه";
    case 2:
      return "یکشنبه";
    case 3:
      return "دوشنبه";
    case 4:
      return "سه‌شنبه";
    case 5:
      return "چهارشنبه";
    case 6:
      return "پنجشنبه";
    case 7:
      return "جمعه";
  }
}

function monthByPersianDigit(number) {
  switch (number) {
    case "۰۱":
      return "فروردین";
    case "۰۲":
      return "اردیبهشت";
    case "۰۳":
      return "خرداد";
    case "۰۴":
      return "تیر";
    case "۰۵":
      return "مرداد";
    case "۰۶":
      return "شهریور";
    case "۰۷":
      return "مهر";
    case "۰۸":
      return "آبان";
    case "۰۹":
      return "آذر";
    case "۱۰":
      return "دی";
    case "۱۱":
      return "بهمن";
    case "۱۲":
      return "اسفند";
  }
}

export function isPersian(str) {
  var regex = /^[\u0600-\u06FF\s]+$/;
  if (!regex.test(str)) {
    return false;
  }
  return true;
}

export default {
  toEnglish,
  // toPersian,
  formatPrice,
  persianPrice,
  weekDayFromNumer,
  monthByPersianDigit,
};
